document.addEventListener('DOMContentLoaded', function() {
  const container = document.getElementById('evento-fields');
  const selectTipoEvento = document.getElementById('evento_tipo_evento');

  if (!container || !selectTipoEvento) return;

  const initialDataPrevisao = container.dataset.initialDataPrevisao || "";
  const initialIndicadorQuitacao = container.dataset.initialIndicadorQuitacao || "1";
  const initialEventoId = container.dataset.initialEventoId || "";

  function getDataPrevisaoEntregaHtml(dataValue, eventoId) {
    return `
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="control-label" for="evento_data_previsao_entrega_attributes_data_previsao_entrega">
              Data Prevista de Entrega
            </label>
            <span class="text-danger">*</span>
            <div class="input-group">
              <span class="input-group-addon">
                <i class="fa fa-calendar"></i>
              </span>
              <input type="text" 
                name="fiscal_nota_fiscal_evento[data_previsao_entrega_attributes][data_previsao_entrega]" 
                id="evento_data_previsao_entrega_attributes_data_previsao_entrega" 
                class="form-control" 
                placeholder="dd/mm/aaaa" 
                required 
                value="${dataValue}">
            </div>
            ${eventoId ? `<input type="hidden" name="fiscal_nota_fiscal_evento[data_previsao_entrega_attributes][id]" value="${eventoId}">` : ''}
          </div>
        </div>
      </div>
    `;
  }

  function getPagamentoIntegralHtml(indicadorValue, eventoId) {
    return `
      <div class="row">
        <div class="col-md-12">
          <div class="alert alert-info" role="alert">
            <i class="fa fa-info-circle"></i>
            <strong>Informação sobre o evento:</strong>
            Este evento registra que houve pagamento integral efetivo da operação, conforme a Reforma Tributária (Lei Complementar nº 214/2025) e a NT 2025.002-RTC. 
            A informação é utilizada para liberar o crédito presumido do adquirente.
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="control-label">
              Indicador de Quitação
            </label>
            <span class="text-danger">*</span>
            <input type="hidden" 
                   name="fiscal_nota_fiscal_evento[pagamento_integral_attributes][indicador_quitacao]" 
                   id="evento_pagamento_integral_attributes_indicador_quitacao"
                   value="${indicadorValue}">
            <p class="form-control-static">
              <strong>1 - Quitação integral confirmada</strong>
              <br>
              <small class="text-muted">
                Este valor indica que o pagamento da operação foi realizado integralmente.
              </small>
            </p>
            ${eventoId ? `<input type="hidden" name="fiscal_nota_fiscal_evento[pagamento_integral_attributes][id]" value="${eventoId}">` : ''}
          </div>
        </div>
      </div>
    `;
  }

  function renderEventoFields(tipoEvento) {
    if (!tipoEvento) {
      container.innerHTML = '<div class="alert alert-info">Selecione um tipo de evento para exibir os campos específicos.</div>';
      return;
    }

    switch(tipoEvento) {
      case 'Fiscal::NotaFiscal::Evento::DataPrevisaoEntrega':
        container.innerHTML = getDataPrevisaoEntregaHtml(initialDataPrevisao, initialEventoId);
        break;
      case 'Fiscal::NotaFiscal::Evento::PagamentoIntegral':
        container.innerHTML = getPagamentoIntegralHtml(initialIndicadorQuitacao, initialEventoId);
        break;
      default:
        container.innerHTML = '<div class="alert alert-info">Selecione um tipo de evento válido.</div>';
    }
  }

  selectTipoEvento.addEventListener('change', function() {
    renderEventoFields(this.value);
  });

  const tipoEventoInicial = selectTipoEvento.value;
  if (tipoEventoInicial) {
    renderEventoFields(tipoEventoInicial);
  }
});
